(function () {
    'use strict';

    angular
        .module('app')
        .factory('refineSearchService', refineSearchService);

    refineSearchService.$inject = ['$http', 'gridDataService', '$localStorage', '$q', 'sidebarservice', 'breadCrumbService', 'lastSearchService', 'loginService'];

    function refineSearchService($http, gridDataService, $localStorage, $q, sidebarservice, breadCrumbService, lastSearchService, loginService) {
        var service = {};
        service.searchCriteria = [];
        service.processing = false;

        service.close = function () {
            service.searchCriteria = [];
        }

        //call to get data from the server
        service.getData = function (skip, take, totalRecords, sort, sortOrder, countOperation, resultType, columns) {

            var deferred = $q.defer();
            var canceller = $q.defer();

            var cancel = function (reason) {
                canceller.resolve(reason);
            }
            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            service.processing = true;
            var request = $http({
                url: '../Synergis.WebApi/api/document/RefineSearch/',
                method: 'POST',
                timeout: canceller.promise,
                responseType: responseType,
                data: JSON.stringify({
                    SearchCriteria: service.searchCriteria,
                    UserId: "",
                    Sort: { SortField: sort, SortOrder: sortOrder },
                    //ViewContext: "",
                    CountOperation: countOperation,
                    ResultType: resultType,
                    Columns: columns,
                    AdeptDataTable: {
                        TableDefinition: null,
                        TableRecords: null,
                        RecordCount: totalRecords,
                        Skip: skip,
                        Take: take,
                    }
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.processing = false;
                gridDataService.serviceIdentifier = "lastSearchService";
                //Breadcrumb
                breadCrumbService.category = loginService.resourceStrings["SEARCH"];

                lastSearchService.getLastSearchAllOperations().then(function (value) {
                    breadCrumbService.details = value;
                    breadCrumbService.node = null;
                });

                deferred.resolve(response);
            }, function (response) {
                service.processing = false;
                deferred.reject(response);
            });

            return {
                promise: deferred.promise,
                cancel: cancel
            }
        };

        service.getCount = function () {
            var deferred = $q.defer();
            service.getData(0, 0, 0, "SCHEMA_S_LONGNAME", 0, true).promise.then(function (response) {
                deferred.resolve(response.data.AdeptDataTable.RecordCount);
            });
            return deferred.promise;
        }

        //information for error handler
        service.getData.description = "getData";
        service.getCount.description = "getCount";

        return service;
    }
})();